namespace TabAurous.Administration {
    export interface SequenceDetailsRow {
        DetailId?: number;
        SequenceId?: number;
        DepartmentId?: number;
        ProcessId?: number;
        Priority?: number;
        DeptName?: string;
        ProcessName?: string;
    }

    export namespace SequenceDetailsRow {
        export const idProperty = 'DetailId';
        export const localTextPrefix = 'Administration.SequenceDetails';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            DetailId = "DetailId",
            SequenceId = "SequenceId",
            DepartmentId = "DepartmentId",
            ProcessId = "ProcessId",
            Priority = "Priority",
            DeptName = "DeptName",
            ProcessName = "ProcessName"
        }
    }
}
